import React, { useEffect, useState } from 'react';
import Network from './Requests';
import ReactFileReader from 'react-file-reader';
import { useDispatch } from 'react-redux';
import { setCurrentUser } from '../store/reducers/usersSlice';
import { useTranslation } from "react-i18next";

const Profile = (props) => {
  const [user, setUser] = useState({});
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const fetch = async () => {
      const userInfo = await new Network().GetUsersInfo();
      dispatch(setCurrentUser(userInfo));
      const data = {
        guid: userInfo.guid,
        data: {
          login: { name: t("profilePage.fields.login"), value: userInfo.login, nameInput: 'login' },
          name: { name: t("profilePage.fields.name"), value: userInfo.name, nameInput: 'name' },
          lastName: { name: t("profilePage.fields.lastName"), value: userInfo.lastName, nameInput: 'lastName' },
          patronymic: { name: t("profilePage.fields.patronymic"), value: userInfo.patronymic, nameInput: 'patronymic' },
          email: { name: t("profilePage.fields.email"), value: userInfo.email, nameInput: 'email' },
          phone: { name: t("profilePage.fields.phone"), value: userInfo.phone, nameInput: 'phone' },
        },
        avatar: userInfo.profilePictureFilePath,
      };
      setUser(data);
    };
    fetch();
  }, [dispatch, t]);

  const changeInput = (e) => {
    document.querySelectorAll('[name=""]').forEach((elem) => (elem.disabled = true));
    document.querySelectorAll('[name="' + e + '"]').forEach((elem) => (elem.disabled = false));
  };

  const handlerBlur = (e) => {
    document.querySelectorAll('[name="' + e + '"]').forEach((elem) => (elem.disabled = true));
  };

  const updateMessageInputValue = (evt) => {
    const nameInp = evt.target.name;
    const valueInp = evt.target.value;

    setUser((prevState) => ({
      ...user,
      data: {
        ...prevState.data,
        [nameInp]: {
          ...prevState.data[nameInp],
          value: valueInp,
        },
      },
    }));
  };

  const close = () => {
    props.close();
  };

  const save = async () => {
    await new Network().updateUser(
      user.data.name.value,
      user.data.lastName.value,
      user.data.patronymic.value,
      user.data.email.value,
      user.data.phone.value,
    );
    props.close();
  };

  const handleFiles = async (files) => {
    const formData = new FormData();
    formData.append('userGuid', user.guid);
    formData.append('picture', files[0]);
    const updateAvatarUser = await new Network().updateAvatarUser(user.guid, formData);
    setUser({
      ...user,
      avatar: updateAvatarUser.replace(/['"]+/g, ''),
    });
  };

  return (
    <div className="profile">
      <ReactFileReader handleFiles={handleFiles}>
        <div className="profile--img--container">
          <img src={user.avatar} className="profile--img" alt="avatar" />
        </div>
      </ReactFileReader>
      {user.data &&
        Object.keys(user.data)?.map((c, index) => (
          <div key={index} className="flex-base jc-b ai-c">
            <span>{user.data[c].name}</span>:{' '}
            <input
              className="value"
              name={user.data[c].nameInput}
              value={user.data[c].value}
              disabled="disabled"
              onBlur={() => handlerBlur(c)}
              onChange={(event) => updateMessageInputValue(event)}
              autoComplete="off"
            />
            <span className="edit" onClick={() => changeInput(c)}></span>
          </div>
        ))}
      <div className="buttons-menu">
        <button onClick={close}>
          {t("profilePage.buttons.cancel")}
        </button>
        <button onClick={save}>
          {t("profilePage.buttons.save")}
        </button>
      </div>
    </div>
  );
};

export default Profile;
